import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=2958e6cf&scoped=true&"
import script from "./NotificationAlert.vue?vue&type=script&lang=ts&"
export * from "./NotificationAlert.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAlert.vue?vue&type=style&index=0&id=2958e6cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2958e6cf",
  null
  
)

export default component.exports